export default __webpack_public_path__ + "static/media/github-2.a855c397.png";